import { Base } from '@studiometa/js-toolkit';
import { removeClass, toggleClass } from '@studiometa/js-toolkit/utils';
import Menu from './Menu.js';
import LocalizationMenu from './LocalizationMenu.js';
import AccordionMenu from './AccordionMenu.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      LocalizationMenu,
      AccordionMenu,
    },
  };

  /**
   *
   */
  mounted() {
    this.setMobileHeight();
  }

  /**
   *
   */
  setMobileHeight() {
    document.documentElement.style.setProperty(
      '--mobile-menu-height',
      `${this.$el.offsetHeight}px`,
    );
  }

  /**
   * Set height
   * @param {HTMLElement} currentMenu The current menu
   */
  setHeight(currentMenu) {
    const menuList = currentMenu.querySelector('.menu-list');
    if (menuList) {
      const menuHeight = menuList.offsetHeight;

      document.documentElement.style.setProperty(
        '--menu-height',
        `${this.$el.offsetHeight + menuHeight}px`,
      );
    }
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 128;

    toggleClass(document.documentElement, 'is-on-top', isOnTop);
    toggleClass(document.documentElement, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.documentElement, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.documentElement, 'is-scrolling-up', direction.y === 'UP');
    toggleClass(this.$el, 'header--solid', direction.y === 'UP');

    if (isNearTop) {
      removeClass(this.$el, 'header--solid');
    }
  }

  /**
   * @param {object} props Props
   * @param {object} props.event Event
   */
  onMenuOpen({ event }) {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.documentElement, 'is-menu-open', openedMenus.length > 0);
    this.setHeight(event.target);
  }

  /**
   *
   */
  onMenuClose() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.documentElement, 'is-menu-open', openedMenus.length > 0);
  }
}
